import '../Scss/main.scss';

import { initializeAccordion } from './components/accordion.js';
import { initializeTabs } from './components/tabs.js';
import { initializeSlider } from './components/slider.js';
import { initializeFilterblog } from './components/filter-blog.js';
import { initializeFilterjob } from './components/filter-stellenangebote.js';
import { openCareer } from "./components/open-career.js";
import { openSearch } from "./components/open-search.js";
import { navigationScroll } from './layout/navigationScroll.js';
import { navigationMobile }  from './components/mobile-navigation.js';
import { sliderPopup } from './components/slider-img-pop-up.js';
import { tapulatorSearch } from './components/tapulator_search.js';
import { initializeExpertise } from "./components/expertise.js";
import  './components/copyURL.js';



// initialize all Components after document is ready
$(document).ready(function() {
    openSearch();
    navigationScroll();
    navigationMobile();
    initializeSlider();
    initializeAccordion();
    initializeTabs();
    openCareer();
    initializeFilterblog();
    sliderPopup();
    tapulatorSearch();
    initializeFilterjob();
    initializeExpertise();
});
